<div
    id="clipboardContainer"
    [innerHtml]="renderedHtml() | unsafe: 'html'"></div>
